/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Options/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Option from './Option/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Options({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions/Options"
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let imageCardPatientImageSlotKeyValueData = fromData.useDataValue({ viewPath,
context: 'image_card',
path: 'patient_image.slot_key',
})
let appPropertiesAudaxCephEnabledValueData = fromData.useDataValue({ viewPath,
context: 'app_properties',
path: 'audax_ceph_enabled',
})
let aggregateData = fromHelpers.getThreeDotsMenu(optionsValueData, imageCardPatientImageSlotKeyValueData, appPropertiesAudaxCephEnabledValueData)
  return (<React.Fragment
>
<div
  data-testid="Options.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(aggregateData) && aggregateData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="option"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Option(${item?.id ?? item?._id ?? index})`}
      >
<Option
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Option(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }